import { __exports as t } from "./index121.js";
import { __require as s } from "./index115.js";
import { __require as c } from "./index93.js";
import { __require as _ } from "./index92.js";
var n;
function l() {
  if (n) return t;
  n = 1;
  var a = t && t.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.Screen = void 0;
  var u = a(s()), o = c(), p = _();
  function r(e, i) {
    o.Page.call(this, e, i);
  }
  return t.Screen = r, u.default(r, o.Page), r.prototype.action = function() {
    return "screen";
  }, r.prototype.type = r.prototype.action, r.prototype.event = function(e) {
    return e ? "Viewed " + e + " Screen" : "Loaded a Screen";
  }, r.prototype.track = function(e) {
    var i = this.json();
    return i.event = this.event(e), i.timestamp = this.timestamp(), i.properties = this.properties(), new p.Track(i, this.opts);
  }, t;
}
export {
  l as __require
};
//# sourceMappingURL=index94.js.map
